import { Routes, Route, Navigate } from "react-router-dom";
import { ROUTES } from "./constants/_routes";
import { baseUrl } from "./services";

import SignIn from "./modules/Authentications/SignIn/SignIn";
import SignUpNew from "./modules/Authentications/SignUp/SignUpNew";
import Global from "./modules/Global/Global";
import Logout from "./modules/Authentications/Logout/Logout";
import Paymob from "./modules/Paymob/Paymob";
import PostPay from "./modules/Paymob/PostPay";
import About from "./modules/About/About";
import LayoutWithNav from "./modules/Layouts/LayoutWithNav";
import PrivacyPolicy from "./modules/PrivacyPolicy";
import LuckyHour from "./modules/LuckyHour";
import ExtendedItems from "./modules/ExtendedItems";
// import StoreItems from "./modules/StoreItems";
import Bidders from "./modules/Bidders";
import AuctionChat from "./modules/Bidders/AuctionChat";
import BuyAndSupply from "./modules/BuyAndSupply";
import Buy from "./modules/BuyAndSupply/Buy";
import Supply from "./modules/BuyAndSupply/Supply";
import Merchant from "./modules/Merchant";
import StartupVideo from "./modules/StartupVideo/StartupVideo";
import Partnerships from "./modules/Partnerships";
import RentWerhouse from "./modules/RentWarehouse";
import { useSelector } from "react-redux";
import SignUp from "./modules/Authentications/SignUp/SignUp";

function RouterFile() {
  const isLive = baseUrl === "https://api.thegreenmatter.com/";
  const { authorization } = useSelector((state) => state?.auth);
  const isEmirates = authorization?.isEmirate;

  return (
    <Routes>
      <Route element={<LayoutWithNav />}>
        {!isEmirates && <Route path={ROUTES.GLOBAL} element={<Global />} />}
        <Route path={ROUTES.ABOUT} element={<About />} />
        {!isEmirates && (
          <Route path={ROUTES.LUCKYHOURS} element={<LuckyHour />} />
        )}
        {!isEmirates && (
          <Route path={ROUTES.EXTEND_MY_STORAGE} element={<ExtendedItems />} />
        )}
        {!isLive && !isEmirates ? (
          <>
            <Route path={ROUTES.BIDDERS} element={<Bidders />} />
            <Route
              path={`${ROUTES.BIDDERS}${ROUTES.AUCTION}`}
              element={<AuctionChat />}
            />
          </>
        ) : (
          ""
        )}
        {/*<Route path={ROUTES.STORE} element={<StoreItems />} />*/}
        {!isEmirates && (
          <Route path={ROUTES.PARTNERSHIPS} element={<Partnerships />} />
        )}
        {!isEmirates && <Route path={ROUTES.MERCHANT} element={<Merchant />} />}
        <Route path={ROUTES.BUYANDSUPPLY} element={<BuyAndSupply />}>
          <Route path={""} element={<Navigate to={ROUTES.BUY} />} />
          <Route path={ROUTES.BUY} element={<Buy />} />
          <Route path={ROUTES.SUPPLY} element={<Supply />} />
        </Route>
        {!isEmirates && (
          <Route path={ROUTES.RENT_WAREHOUSE} element={<RentWerhouse />} />
        )}
      </Route>
      <Route path={ROUTES.STARTUPVIDEO} element={<StartupVideo />} />
      <Route path={ROUTES.SIGNIN} element={<SignIn />} />
      <Route path={ROUTES.PRIVACYPOLICY} element={<PrivacyPolicy />} />
      <Route path={ROUTES.SIGNUP} element={<SignUpNew />} />
      {/* <Route path={ROUTES.SIGNUP} element={<SignUp />} /> */}
      <Route path={ROUTES.LOGOUT} element={<Logout />} />
      <Route path={ROUTES.PAYMOB} element={<Paymob />} />
      <Route path={ROUTES.POSTPAY} element={<PostPay />} />
      <Route
        path="*"
        element={
          <Navigate
            to={
              authorization?.token
                ? isEmirates
                  ? "/buy-and-supply/buy"
                  : ROUTES.GLOBAL
                : ROUTES.SIGNIN
            }
            replace
          />
        }
      />
    </Routes>
  );
}
export default RouterFile;
